import React, {Fragment} from "react"
import Slider from "react-slick";

const feedbackContent = [
    {
        title: "La mejor agencia de software del nuevo mundo",
        desc: "Diseñar de manera creíble mercados nicho empoderados a través de vortales superiores. Mantener interactivamente datos impulsados por el equipo para fuentes internas de alto impacto a largo plazo u 'orgánicas'. Integrar apropiadamente ideas revolucionarias y tecnologías multimedia.",
        img: "author-4b",
        author: "Kristin Watson",
        desig: "Coordinador de Marketing",
    },
    {
        title: "Equipo de soporte dedicado 24/7",
        desc: "Diseñar de manera creíble mercados nicho empoderados a través de vortales superiores. Mantener interactivamente datos impulsados por el equipo para fuentes internas de alto impacto a largo plazo u 'orgánicas'. Integrar apropiadamente ideas revolucionarias y tecnologías multimedia.",
        img: "author-5b",
        author: "Darrell Steward",
        desig: "Asistente Médico",
    },
    {
        title: "La mejor agencia de software del nuevo mundo",
        desc: "Diseñar de manera creíble mercados nicho empoderados a través de vortales superiores. Mantener interactivamente datos impulsados por el equipo para fuentes internas de alto impacto a largo plazo u 'orgánicas'. Integrar apropiadamente ideas revolucionarias y tecnologías multimedia.",
        img: "author-4b",
        author: "Kristin Watson",
        desig: "Coordinador de Marketing",
    },
    {
        title: "Equipo de soporte dedicado 24/7",
        desc: "Diseñar de manera creíble mercados nicho empoderados a través de vortales superiores. Mantener interactivamente datos impulsados por el equipo para fuentes internas de alto impacto a largo plazo u 'orgánicas'. Integrar apropiadamente ideas revolucionarias y tecnologías multimedia.",
        img: "author-5b",
        author: "Darrell Steward",
        desig: "Asistente Médico",
    },
];

const settings = {
    dots: true,
    arrows: false,
    infinite: true,
    loop: true,
    autoplay: true,
    autoplaySpeed: 2000,
    slidesToShow: 2,
    slidesToScroll: 1,
    padding:15,
    responsive: [
        {
            breakpoint: 991,
            settings: {
                slidesToShow: 1,
            }
        }
    ]
};

const FeedbackTwo = () => {
    return (
        <Fragment>
            <Slider {...settings} className="row gx-0 feedback-slider-two">
                {feedbackContent.map((val,i)=>(
                    <div key={i} className="col-lg-6">
                        <div className="feedback-style-two">
                            <h4 className="fw-medium mb-25">" La mejor agencia de software del nuevo mundo "</h4>
                            <p>C{val.desc}</p>
                            <div className="d-sm-flex align-items-center justify-content-between">
                                <div className="author d-flex align-items-center justify-content-center mt-35">
                                    <img src={`assets/img/testimonial/${val.img}.jpg`} alt="author"/>
                                    <div className="author-info">
                                        <h4>{val.author}</h4>
                                        <p className="text-white">{val.desig}</p>
                                    </div>
                                </div>
                                <div className="rating mt-35">
                                    <a href="#">
                                        <i className="bi bi-star-fill"/>
                                    </a>
                                    <a href="#">
                                        <i className="bi bi-star-fill"/>
                                    </a>
                                    <a href="#">
                                        <i className="bi bi-star-fill"/>
                                    </a>
                                    <a href="#">
                                        <i className="bi bi-star-fill"/>
                                    </a>
                                    <a href="#">
                                        <i className="bi bi-star-fill"/>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                ))}
            </Slider>
        </Fragment>
    )
}

export default FeedbackTwo